import React from 'react';
import { Helmet } from 'react-helmet';
import useFirestoreSubscribe from '@paperstac/hooks/lib/useFirestoreSubscribe';
import { settingsRef } from '@paperstac/firestore-collections/lib/settings';
import { useLocation } from 'react-router-dom';
import IdentityManager from '../common/IdentityManager';
import MaintenanceSplash from '../common/MaintenanceSplash';
import ServiceWorkerRefresh from '../common/ServiceWorkerRefresh';
import LegacyToaster from '../Toaster';
import { Toaster } from '@paperstac/ui/lib/Toast';

const MaintenanceGate = React.memo(({ children, isMaintenanceMode }) => {
  const location = useLocation();
  const isAdminPath = location.pathname.includes('/admin');

  if (isMaintenanceMode && !isAdminPath) return <MaintenanceSplash />;
  return children;
});

const BaseLayout = React.memo(({ children, title = 'Untitled Page | Paperstac' }) => {
  const [settings] = useFirestoreSubscribe(settingsRef(), []);
  const isMaintenanceMode = !!settings?.maintenanceMode;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="Description"
          content="Paperstac - the digital mortgage note transaction engine. Sell mortgage notes faster, buy mortgage notes easier. View mortgage notes for sale or list for free."
        />
        <meta
          itemProp="description"
          content="Paperstac - the digital mortgage note transaction engine. Sell mortgage notes faster, buy mortgage notes easier. View mortgage notes for sale or list for free."
        />
      </Helmet>
      <LegacyToaster />
      <Toaster />
      <ServiceWorkerRefresh />
      <IdentityManager>
        <MaintenanceGate isMaintenanceMode={isMaintenanceMode}>{children}</MaintenanceGate>
      </IdentityManager>
    </>
  );
});

BaseLayout.propTypes = {};

BaseLayout.defaultProps = {};

BaseLayout.displayName = 'BaseLayout';

export default BaseLayout;
